export default __webpack_public_path__ + "static/media/oraclelogo.584b4d28.png";